<template>
  <div class="ticket-wrapper">
    <BoardSearch/>
    <b-nav pills class="ticket-nav">
      <b-nav-item :active="!complete" @click="filterTickets('active')">
        Active Tickets
      </b-nav-item>
      <b-nav-item :active="complete" @click="filterTickets('complete')">
        Complete Tickets
      </b-nav-item>
      <b-btn @click="sortTickets" id="sort-button" variant="outline-info">
        Sort Tickets
        <fa v-if="order === 'asc'" icon="chevron-up" />
        <fa v-if="order === 'desc'" icon="chevron-down" />
      </b-btn>
      <b-tooltip target="sort-button" placement="bottom" triggers="hover">
        {{ orderTooltipTitle }}
      </b-tooltip>
      <div v-if="user" class="assigned">
        <span v-if="taskCount == 1">{{ taskCount }} assigned task</span>
        <span v-else>{{ taskCount }} assigned tasks</span>
      </div>
      <b-btn @click="toggleAllTickets" variant="outline-info">
        {{ toggleStateText }}
      </b-btn>
    </b-nav>
    <transition name="fade">
      <div v-if="loadingData === true" class="loading">
        <div class="loading-icon">
          <fa icon="sync-alt" spin/>
        </div>
        <div class="loading-text">
          Loading tickets...
        </div>
      </div>
    </transition>
    <div v-if="loadingData == false">
      <div v-if="tickets.length > 0" class="ticket-section">
        <div class="totals-pagination">
          <div class="totals-row">
            <span class="viewing-text"> Viewing </span><span class="range1 viewing-text">{{ pageMin }}</span>
            <span class="viewing-text">-</span>
            <span class="range2 viewing-text">{{ pageMax }} of {{ totalTickets }}</span>
          </div>
          <div  class="pagination-row">
            <template v-if="page !== 1">
              <span class="all-previous" @click="setPage(1)"><span class="oi oi-chevron-left"></span><span class="oi oi-chevron-left"></span></span>&nbsp;
              <span class="previous" @click="setPage(page - 1)"><span class="oi oi-chevron-left" ></span></span>&nbsp;
            </template>
            <template v-if="pageMax < totalTickets">
              <span class="next" @click="setPage(page + 1)"><span class="oi oi-chevron-right"></span></span>&nbsp;
              <span class="all-next" @click="setPage(Math.ceil(totalTickets / perPage))"><span class="oi oi-chevron-right"></span><span class="oi oi-chevron-right"></span></span>
            </template>
          </div>
        </div>
        <hr/>
        <template v-if="user == true">
          <Ticket v-for="ticket in tickets" :key="ticket.id" :ticket="ticket" :user="currentUser"/>
        </template>
        <template v-else>
          <Ticket v-for="ticket in tickets" :key="ticket.id" :ticket="ticket"/>
        </template>
        <hr/>
        <div class="totals-pagination">
          <div class="totals-row">
            <span class="viewing-text"> Viewing </span><span class="range1 viewing-text">{{ pageMin }}</span>
            <span class="viewing-text">-</span>
            <span class="range2 viewing-text">{{ pageMax }} of {{ totalTickets }}</span>
          </div>
          <div class="pagination-row">
            <template v-if="page !== 1">
              <span class="all-previous" @click="setPage(1)"><span class="oi oi-chevron-left"></span><span class="oi oi-chevron-left"></span></span>&nbsp;
              <span class="previous" @click="setPage(page - 1)"><span class="oi oi-chevron-left" ></span></span>&nbsp;
            </template>
            <template v-if="pageMax < totalTickets">
              <span class="next" @click="setPage(page + 1)"><span class="oi oi-chevron-right"></span></span>&nbsp;
              <span class="all-next" @click="setPage(Math.ceil(totalTickets / perPage))"><span class="oi oi-chevron-right"></span><span class="oi oi-chevron-right"></span></span>
            </template>
          </div>
        </div>
      </div>
      <div v-else>
        <p>No tickets here!</p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Ticket from './Ticket'
import BoardSearch from './BoardSearch'
export default {
  name: 'TicketWrapper',
  props: {
    user: Boolean
  },
  components: {
    Ticket,
    BoardSearch
  },
  data () {
    return {
      taskCount: 0,
      taskObject: {},
      complete: false,
      page: 1,
      totalTickets: 0,
      perPage: 25,
      pageMin: 0,
      pageMax: 0,
      active: 0,
      loadingData: false,
      params: {},
      order: 'desc',
      toggleState: false
    }
  },
  created () {
    this.filterTickets('active')
  },
  mounted () {
    this.$root.$on('ticketDeleted', (ticketId) => {
      var ticketIndex = this.tickets.findIndex(ticket => ticket.id === ticketId)
      this.tickets.splice(ticketIndex, 1)
    })
  },
  methods: {
    ...mapActions(['loadTickets']),
    toggleAllTickets () {
      this.$root.$emit('toggleTicketCollapse', this.toggleState)
      this.toggleState = !this.toggleState
    },
    getTickets () {
      var params = this.params
      if (params.user_id === null && params.board_id === null) {
        this.loadingData = false
        return
      }
      this.loadTickets(params)
    },
    setPage (num) {
      this.page = num
      this.params.page = this.page
      this.getTickets()
    },
    calcMinMax () {
      var newMin = (this.perPage * this.page) - this.perPage + 1
      if (this.tickets.length > 0) {
        this.pageMin = newMin > 0 ? newMin : 1
      } else {
        this.pageMin = 0
      }
      var newMax = this.perPage * this.page
      if (newMax > this.totalTickets) {
        this.pageMax = this.totalTickets
      } else if (newMax < this.perPage) {
        this.pageMax = this.perPage
      } else {
        this.pageMax = this.perPage * this.page
      }
    },
    setParams () {
      var paramsHash = {complete: this.complete, page: this.page, order: this.order}
      if (this.user === true) {
        paramsHash.user_id = this.currentUser.id
      } else if (this.currentBoard) {
        paramsHash.board_id = this.currentBoard.id
      }
      this.params = paramsHash
      this.getTickets()
    },
    filterTickets (folder) {
      window.history.replaceState(null, null, '?q=' + folder)
      this.page = 1
      if (folder === 'active') {
        this.complete = false
      } else {
        this.complete = true
      }
      this.setParams()
    },
    sortTickets () {
      if (this.order === 'desc') {
        this.order = 'asc'
      } else {
        this.order = 'desc'
      }
    }
  },
  computed: {
    ...mapGetters(['currentUser', 'tickets', 'currentBoard']),
    orderTooltipTitle () {
      if (this.order === 'desc') {
        return 'Newest first'
      } else {
        return 'Oldest first'
      }
    },
    toggleStateText () {
      return this.toggleState ? 'Expand All Tickets' : 'Collapse All Tickets'
    }
  },
  watch: {
    currentBoard () {
      this.filterTickets('active')
    },
    order () {
      this.setParams()
    }
  }
}
</script>

<style scoped>
  .ticket-wrapper {
    margin-top: 10px;
  }
  .fade-transition {
    transition: opacity 8000ms ease;
  }
  .fade-transition.loading {
    z-index: 1;
    position: absolute;
    top: 0;
    left: 15px;
    right: 15px;
  }
  .fade-enter,
  .fade-leave {
    opacity: 0;
  }
  .totals-pagination {
    height: 15px;
    margin-top: 10px;
  }
  .totals-row {
    float: left;
    color: #7a8da0;
  }
  .pagination-row {
    float: right;
  }
  span.oi {
    color:#7a8da0;
  }
  .all-previous, .previous {
    visibility: visible;
  }
  .all-next, .next {
    visibility: visible;
  }
  a:visited.nav-link {
    color: #0563C1;
  }
  a:visited.nav-link.active {
    color: #FFF;
  }
  .assigned {
    color: #6C757D;
    padding: 8px 16px;
  }
  #sort-button {
    margin-left: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/TicketWrapper.vue